///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, rgpdActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postSearchCustomer = function* ({ payload }) {
	const bodyMsg = payload.customer
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_SEARCH_CUTOMER(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(rgpdActionCreators.postSearchCustomerSuccess(data))
	} catch (e) {
		let error = e.response

		if (error.status === 400) {
			yield put(rgpdActionCreators.postSearchCustomerFailure(e.response))
		} else {
			yield put(errorManagerActionCreators.createError(e.response))
		}
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postCustomerData = function* ({ payload }) {
	const bodyMsg = payload.customer

	const user = yield select(selectIdsUser)
	const apiCall = R.POST_CUSTOMER_DATA()
	//yield put(globalLoadingActionCreators.startLoading());

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(rgpdActionCreators.postCustomerDataSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rgpdActionCreators.postCustomerDataFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postAnonymiseData = function* ({ payload }) {
	const bodyMsg = payload.customer
	const MsgParams = 'toast__rgpd__summarySend'
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_ANONYMISE_DATA()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(rgpdActionCreators.postAnonymiseDataSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rgpdActionCreators.postAnonymiseDataFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_SEARCH_CUTOMER, postSearchCustomer)
	yield takeLatest(ActionsTypes.POST_CUSTOMER_DATA, postCustomerData)
	yield takeLatest(ActionsTypes.POST_ANONYMISE_DATA, postAnonymiseData)
}

export default sagas
